export var COMPONENT_KEY = 'component-language-selector-i18n';